import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Geral',
    [tabs.restaurant_details]: 'Detalhes do restaurante',
    [tabs.order_conversion]: 'Conversão de encomendas',
    [tabs.external_delivery]: 'Entrega externa',
    [tabs.mobile_app]: 'App móvel',
    [tabs.customer_success_team]: 'Equipa de sucesso do cliente',
    [tabs.onboarding_team]: 'Equipa de onboarding',
  },
  date_range: {
    this_month: 'Este Mês',
    last_month: 'Mês Passado',
    last_week: 'Semana Passada',
    last_year: 'Ano Passado',
    this_week: 'Esta Semana',
    this_year: 'Este Ano',
    today: 'Hoje',
    yesterday: 'Ontem',
    all: 'Tudo',
  },
};
